class AccountDrawer extends Drawer {
    constructor() {
        super();

        this.isDesktop = window.innerWidth > 1024;
        if (!this.isDesktop) return
        const opener =  document.querySelector('#account-icon-bubble');
        this.setIconAccessibility(opener);
    }

    open() {
        super.open()
        if(!this.isDesktop){
            document.body.classList.remove('overflow-hidden');
            setTimeout(() => {
                this.close();
            }, 3000);
        }
    }

    renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.querySelector('[data-overlay]').addEventListener('click', this.close.bind(this));
            this.open();
            super.setListeners()
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'account-drawer',
                selector: '#AccountDrawer',
            },
            {
                id: 'account-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('account-drawer', AccountDrawer);
